"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplatesContract = void 0;
const core_1 = require("@ts-rest/core");
const messages_1 = require("./messages");
const offer_letters_1 = require("./offer-letters");
const offer_reminders_1 = require("./offer-reminders");
const c = (0, core_1.initContract)();
exports.TemplatesContract = c.router({
    messages: messages_1.MessageTemplatesContract,
    offerLetters: offer_letters_1.OfferLetterTemplatesContract,
    offerReminders: offer_reminders_1.OfferReminderTemplatesContract,
}, { pathPrefix: '/templates' });
